export default {"src":"/_next/static/media/MRO.2ea53516.svg","height":18,"width":18};